import React, { Fragment } from 'react';
import { Link } from "react-router-dom";

const Formnvoserver = (props) => {
    return (
        <Fragment>
            <form onSubmit={props.handleSubmit()} autoComplete="off">
                <div className="row">
                    <div className="col-md-12">
                        <label>Nombre del servidor</label>
                        <input onChange={props.handleChange()} type="text" className="form-control" name="nombre" id="nombre" value={props.dataState.nombre || ""} />
                    </div>
                    <div className="mt-2 inline"></div>
                    <div className="col-md-12">
                        <label>Habilitar/Deshabilitar</label>
                        {props.dataState.estado === "1" ?
                            <div className="custom-control custom-switch">
                                <input onChange={props.handleCheck()} defaultChecked={props.habilitado} type="checkbox" className="custom-control-input" id="estado" name="estado" value="1" checked />
                                <label className="custom-control-label" htmlFor="estado"></label>
                            </div>
                            :
                            <div className="custom-control custom-switch">
                                <input onChange={props.handleCheck()} defaultChecked={props.habilitado} type="checkbox" className="custom-control-input" id="estado" name="estado" value="1" />
                                <label className="custom-control-label" htmlFor="estado"></label>
                            </div>
                        }
                    </div>
                    <div className="col-md-12">
                        <label>IP del servidor</label>
                        <input onChange={props.handleChange()} type="text" className="form-control" name="ip" id="ip" value={props.dataState.ip || ""} />
                    </div>
                    <div className="mt-2 inline"></div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <hr />
                        <button type="submit" className="btn btn-primary">Guardar</button>
                        <Link to="/servidores" className="btn btn-danger ml-3">Cancelar</Link>
                    </div>
                </div>
            </form>
        </Fragment>
    );
};

export default Formnvoserver;


// WEBPACK FOOTER //
// ./src/components/servers/Formnvoserver.js